import { BarChart, Button, FormField, Table, Tabs } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
import { useStore } from '../../../store';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { BarChartProps } from '@cloudscape-design/components/bar-chart';
import {
    colorChartsStatusHigh,
    colorChartsStatusInfo
} from '@cloudscape-design/design-tokens';
import Favorites from '../../../../../components/extras/Favorites';
import MPModal from '../../../../../components/MPModal';
import UserPicker from '../../../../../components/UserPicker';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';

const pageSize = 20;
type ChartType = "bar" | "line" | "threshold"; // Add others as needed

type ItemData = {
    x: Date;
    y: number;

}
type ItemMonth = {
    title: string;
    type: ChartType;
    data: ItemData[];

}
export const ReportsFinanceInOutPage = () => {
    const { idUser, menu, parameters } = useGlobalState();

    const [keyw, setKeyw] = useState("");

    const [pendingJobCreation, setPendingJobCreation] = useState(false);


    const [helpOpen, setHelpOpen] = useState(false);
    const [sideOpen, setSideOpen] = useState(false);
    const [userPickerModal, setUserPickerModal] = useState(false);
    const [activeTab, setActiveTab] = useState("monthly");

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();



    const [checks, setChecks] = useState<ItemCheck[]>([]);
    const [pendings, setPendings] = useState<ItemCheck[]>([]);
    const [mychecks, setMychecks] = useState<ItemCheck[]>([]);
    const [dataMonth, setDataMonth] = useState<BarChartProps<Date>['series']>([]);




    type ItemCheck = {
        idCheck: number;
        idRequest: number;
        statusRequest: number;
        idUser: number;
        idInstructor: number;
        check: string;
        displayName: string;
        instructor: string;
        dateAssigned: string;
        dateExpires: string;
        dateResult: string;
        dateSubmited: string;
        resultItem: string;

    }
    type ItemAccountPlan = {
        idAccountPlan: number;
        accountPlan: string;
        value: string;
        label: string;
    };
    useEffect(() => {
        if (activeTab == "mychecks")
            handleCheckMine()
        if (activeTab == "pending")
            handleCheckPending()
        //handleGetMonth();
    }, [activeTab]);


    useEffect(() => {
        if (parameters.period !== "") {
            handleGetMonth()
        }
    }, [parameters?.period]);



    const handleGetMonth = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/reports/finance/monthlyincome',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    month: parameters.period.split("-")[1],
                    year: parameters.period.split("-")[0],
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data && data.report) {
                //setMychecks(data.checks);

                const chartSeries: BarChartProps<Date>['series'] = data.report.map((item: { title: any; data: any[]; }) => ({
                    title: item.title,
                    type: 'bar',
                    //color:"#f0f0f0",
                    valueFormatter: (e: { toLocaleString: (arg0: string, arg1: { minimumFractionDigits: number; maximumFractionDigits: number; }) => string; }) =>
                        "$" +
                        e.toLocaleString("es-CL", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        }),
                    data: item.data.map(point => ({
                        x: new Date(point.x + 'T00:00'), // Optional,  // this must be a real Date object
                        y: point.y
                    }))
                }));
                chartSeries[0].color = colorChartsStatusHigh
                chartSeries[1].color = colorChartsStatusInfo

                setDataMonth(chartSeries)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }

    }
    const handleCheckMine = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/checks/search.requests',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    idInstructor: idUser,
                    orderBy: "dateSubmited",
                    order: "desc",
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setMychecks(data.checks);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }

    const handleCheckPending = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/checks/search.requests',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    pending: true,
                    orderBy: "dateSubmited",
                    order: "desc",
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setPendings(data.checks);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const handleCheckSearch = async () => {
        if (keyw.length >= 3) {
            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/checks/search.requests',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        keyw: keyw,
                        orderBy: "dateSubmited",
                        order: "desc",
                    }),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    setChecks(data.checks);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }
        }
    }

    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={sideOpen}
            onSplitPanelToggle={({ detail }) => setSideOpen(detail.open)}

            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>

                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />} //info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                        >
                            Ingersos/Egresos
                        </Header>


                        {parameters.startDate !== '' && parameters.endDate !== '' && (

                            <Tabs
                                activeTabId={activeTab}
                                onChange={({ detail }) => {
                                    setActiveTab(detail.activeTabId);
                                }}
                                key={"mo"}
                                tabs={[
                                    {
                                        label: "Mensualizado",
                                        id: "monthly",
                                        content: (
                                            <SpaceBetween direction='vertical' size='xs'>
                                                <div style={{ width: 130 }}>
                                                    <MPModal
                                                        width={120}
                                                        today prevMonth nextMonth end={new Date()}
                                                        date={`${parameters.year}-${parameters.month}`}
                                                        onConfirm={(date) => {
                                                            setParameters({ ...parameters, month: date.month, year: date.year });
                                                        }}
                                                    />
                                                </div>
                                                <BarChart series={dataMonth}
                                                    i18nStrings={{
                                                        xTickFormatter: e =>
                                                            e
                                                                .toLocaleDateString("es-CL", {
                                                                    month: "short",
                                                                    day: "numeric",
                                                                })
                                                                .split(",")
                                                                .join("\n"),
                                                        yTickFormatter: function o(e) {
                                                            return Math.abs(e) >= 1e9
                                                                ? (e / 1e9).toFixed(1).replace(/\.0$/, "") +
                                                                "G"
                                                                : Math.abs(e) >= 1e6
                                                                    ? (e / 1e6).toFixed(1).replace(/\.0$/, "") +
                                                                    "M"
                                                                    : Math.abs(e) >= 1e3
                                                                        ? (e / 1e3).toFixed(1).replace(/\.0$/, "") +
                                                                        "K"
                                                                        : e.toFixed(2);
                                                        }
                                                    }}
                                                    ariaLabel="Multiple data series line chart"
                                                    height={300}
                                                    xTitle="Fecha"
                                                    yTitle="Monto"
                                                    empty={
                                                        <Box textAlign="center" color="inherit">
                                                            <b>No data available</b>
                                                            <Box variant="p" color="inherit">
                                                                There is no data available
                                                            </Box>
                                                        </Box>
                                                    }
                                                    noMatch={
                                                        <Box textAlign="center" color="inherit">
                                                            <b>No matching data</b>
                                                            <Box variant="p" color="inherit">
                                                                There is no matching data to display
                                                            </Box>
                                                            <Button>Clear filter</Button>
                                                        </Box>
                                                    }
                                                />
                                            </SpaceBetween>
                                        )
                                    },


                                    {
                                        label: "Anualizado",
                                        id: "yearly",
                                        content: (
                                            <SpaceBetween direction='vertical' size='xs'>
                                                {pendings.length > 0 && (
                                                    <Table
                                                        stickyHeader
                                                        columnDefinitions={[
                                                            {
                                                                id: "idRequest",
                                                                header: "Fecha",
                                                                cell: item => (

                                                                    <FormField
                                                                        description={`ID ${item.idRequest}`}
                                                                        label={item.dateSubmited}
                                                                    />
                                                                ),
                                                                width: 120
                                                            },
                                                            {
                                                                id: "idUser",
                                                                header: "Usuario",
                                                                cell: item => (

                                                                    <FormField
                                                                        description={item.instructor !== "" ? item.instructor : (<strong>Sin asignación</strong>)}
                                                                        label={item.displayName}
                                                                    />
                                                                )
                                                            },
                                                            {
                                                                id: "check",
                                                                header: "Chequeo",
                                                                cell: item => (

                                                                    <FormField
                                                                        description={item.check}
                                                                        label={item.check}
                                                                    />
                                                                )
                                                            },
                                                            {
                                                                id: "statusRequest",
                                                                header: "Acción",
                                                                width: 200,
                                                                cell: item => (

                                                                    <FormField
                                                                        label={
                                                                            item.statusRequest === 0 ?
                                                                                <Button fullWidth variant='primary'>Asignar</Button> :
                                                                                <Button fullWidth>Intercambiar</Button>
                                                                        }
                                                                    />
                                                                )
                                                            },
                                                        ]}
                                                        trackBy="idRequest"
                                                        items={pendings ?? []}
                                                        empty={
                                                            <Box
                                                                margin={{ vertical: "xs" }}
                                                                textAlign="center"
                                                                color="inherit"
                                                            >
                                                                <SpaceBetween size="m">
                                                                    <b>Sin resultados</b>
                                                                </SpaceBetween>
                                                            </Box>
                                                        }
                                                    />
                                                )}
                                            </SpaceBetween>
                                        )
                                    },
                                    {
                                        label: "Mis chequeos",
                                        id: "mychecks",
                                        content: (
                                            <SpaceBetween direction='vertical' size='xs'>
                                                {mychecks.length > 0 && (
                                                    <Table
                                                        stickyHeader
                                                        columnDefinitions={[
                                                            {
                                                                id: "idRequest",
                                                                header: "Fecha",
                                                                cell: item => (

                                                                    <FormField
                                                                        description={`ID ${item.idRequest}`}
                                                                        label={item.dateSubmited}
                                                                    />
                                                                ),
                                                                width: 120
                                                            },
                                                            {
                                                                id: "idUser",
                                                                header: "Usuario",
                                                                cell: item => (

                                                                    <FormField
                                                                        description={item.instructor !== "" ? item.instructor : (<strong>Sin asignación</strong>)}
                                                                        label={item.displayName}
                                                                    />
                                                                )
                                                            },
                                                            {
                                                                id: "check",
                                                                header: "Chequeo",
                                                                cell: item => (

                                                                    <FormField
                                                                        description={item.check}
                                                                        label={item.check}
                                                                    />
                                                                )
                                                            },
                                                            {
                                                                id: "statusRequest",
                                                                header: "Acción",
                                                                width: 140,
                                                                cell: item => (

                                                                    <FormField
                                                                        label={
                                                                            item.dateResult === "" ?
                                                                                <Button fullWidth variant='primary'>Evaluar</Button> : null
                                                                        }
                                                                    />
                                                                )
                                                            },
                                                        ]}
                                                        trackBy="idRequest"
                                                        items={mychecks ?? []}
                                                        empty={
                                                            <Box
                                                                margin={{ vertical: "xs" }}
                                                                textAlign="center"
                                                                color="inherit"
                                                            >
                                                                <SpaceBetween size="m">
                                                                    <b>Sin resultados</b>
                                                                </SpaceBetween>
                                                            </Box>
                                                        }
                                                    />
                                                )}
                                            </SpaceBetween>
                                        )
                                    }
                                ]}
                            />
                        )}
                    </SpaceBetween>

                    <UserPicker
                        visible={userPickerModal}
                        clear={false}
                        close={false}
                        onDismiss={() => {
                            setUserPickerModal(false)

                        }}

                        onConfirm={(user) => {
                            const updatedParameters = {
                                ...parameters, // clone existing keys
                                idUser: Number(user.value), // add or update
                                displayName: user.label // add or update
                            };

                            setParameters(updatedParameters); // updates state + storage
                            setUserPickerModal(false);
                        }}
                    />


                </>
            }
        />
    );
};
